import React, { state } from "react";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker, defaultStaticRanges } from "react-date-range";
import ReactDom from "react-dom";
import { isSameDay, startOfDay } from "date-fns";

const ModalClickDateRange = ({
  openDateRange,
  setOpenDateRange,
  dateRange,
  setDateRange,
  setFilterDate,
}) => {
  const orientation = window.matchMedia("(max-width: 768px)").matches
    ? "vertical"
    : "horizontal";

  const staticRanges = defaultStaticRanges;

  const normalize = (d) => startOfDay(d);

  const findStaticLabel = (selection) => {
    const selStart = normalize(selection.startDate);
    const selEnd = normalize(selection.endDate);

    const match = staticRanges.find((sr) => {
      const r = sr.range();
      const rStart = normalize(r.startDate);
      const rEnd = normalize(r.endDate);
      return isSameDay(rStart, selStart) && isSameDay(rEnd, selEnd);
    });

    return match ? match.label : null;
  };

  return ReactDom.createPortal(
    <div
      id="dropdownDateRangeMenu"
      className={`${
        openDateRange ? "" : "hidden"
      } fixed shadow-lg bg-white py-2 z-[99999] rounded-lg h-fit top-32 md:top-60 border left-10 right-10 md:right-auto md:left-44 flex flex-col justify-center items-center w-fit `}
    >
      <div className="flex flex-col gap-1 w-fit bg-red-200">
        <DateRangePicker
          onChange={(item) => {
            const label = findStaticLabel(item.selection);
            if (label) {
              setFilterDate(label.toLocaleLowerCase().replaceAll(" ", "_"));
            } else {
              setFilterDate(null);
            }
            setDateRange([item.selection]);
          }}
          staticRanges={orientation == "horizontal" ? defaultStaticRanges : []}
          inputRanges={[]}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          ranges={dateRange}
          direction={orientation}
          rangeColors={["#1E3E62"]}
          className="bg-red-200"
        />
      </div>
      <div className="flex flex-row w-full justify-end p-5 gap-5">
        <div
          className="hover:border-secondary hover:text-white cursor-pointer px-10 py-3 rounded-lg bg-white text-primary border-primary border hover:bg-secondary"
          onClick={(_) =>
            setDateRange([
              {
                startDate: null,
                endDate: null,
                key: "selection",
              },
            ])
          }
        >
          Clear
        </div>
        <div
          className="hover:bg-secondary cursor-pointer px-10 py-3 rounded-lg bg-primary text-white border-primary hover:border-secondary border"
          onClick={(_) => setOpenDateRange(false)}
        >
          Apply
        </div>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default ModalClickDateRange;
